/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IComponentOptions, IQService} from 'angular';
import TSGemeinde from '../../../../models/TSGemeinde';
import GemeindeRS from '../../../service/GemeindeRS.rest';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;

declare let require: any;
declare let angular: any;
require('./dv-gemeinde-typeahead.scss');

export class DVGemeindeTypeaheadComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        selectedGemeinde: '=',
        inputName: '@?',
        inputPlaceholder: '@?',
        label: '@',
        clazz: '@',
        ngRequired: '<',
        bisherFs: '<?',
        bisherGs: '<?',
        excludeKantonGr: '<?'
    };
    template = require('./dv-gemeinde-typeahead.html');
    controller = DvGemTypeaheadController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvGemTypeaheadController {

    selectedGemeinde: TSGemeinde;
    ngRequired: boolean;
    valueRequired: boolean = true; // default required
    bisherFs: any;
    bisherGs: any;
    excludeKantonGr: boolean;

    static $inject = ['$log', '$q', 'GemeindeRS'];

    constructor(private $log: ILogService, private $q: IQService, private gemeindeRS: GemeindeRS) {
    }

    $onInit() {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }
    }

    private loadSuggestElements(searchString: string): IPromise<Array<TSGemeinde>> {
        return this.gemeindeRS.readGemeindeSuggestion(searchString, this.excludeKantonGr).then((response) => {
            return response;
        })
    }

    public showBisher(): boolean {
        return (this.bisherFs !== undefined && this.bisherGs !== undefined);
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-typeahead/dv-gemeinde-typeahead/dv-gemeinde-typeahead.ts